import { Injectable } from '@angular/core';
import { ModalController, LoadingController } from 'ionic-angular';
import { CoBibItemPage } from '../../pages/co-bib-item/co-bib-item';
import isIsbn from 'is-isbn';
import { NovelistProvider } from '../../providers/novelist/novelist';
import { IlsProvider } from '../../providers/ils/ils';
import { ToastAlertsProvider } from '../toast-alerts/toast-alerts';
import { BibItem } from '../item/item';
import { CoDigitalItemPage } from '../../pages/co-digital-item/co-digital-item';
import { DigitalItemsProvider } from '../../providers/digital-items/digital-items';
import { OverdriveProvider } from '../../providers/overdrive/overdrive';

/*
  Generated class for the CoBibItemProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CoBibItemProvider {

  // if (this.navParams.data.isbn) {

  //   await this.getNovelistData(this.navParams.get('isbn'));
  //   loader.dismiss();
  //   return true
  // } else if (this.navParams.data.upc) {
  //   await this.getNovelistData(this.navParams.get('upc'));
  //   this.loader.dismiss();
  //   return true
  // } else if (this.navParams.data.barcode) {
  //   await this.ils.getBibDetailsFromBarcode(this.navParams.get('barcode')).then(ilsItem => this.loadNovelistData(ilsItem));
  //   this.loader.dismiss();
  //   return true
  // } else if (this.navParams.data.bibId) {
  //   await this.ils.getBibDetailsFromId(this.navParams.get('bibId')).then(ilsItem => this.loadNovelistData(ilsItem));
  //   this.loader.dismiss();
  //   return true
  // } else {
  //   this.triggerToast('Invalid book');
  //   this.closeModal();
  //   this.loader.dismiss();
  //   return false
  // }


  constructor(public modalCtrl: ModalController, private novelist: NovelistProvider, private ils: IlsProvider, private loading : LoadingController, private toastAlerts:ToastAlertsProvider, private digitalProvider: DigitalItemsProvider, private overdrive: OverdriveProvider) {
  }
  public async  showModal(peramiters):Promise<any>{
    if(peramiters.novelistDetails || peramiters.bibDetails){
      let profileModal = this.modalCtrl.create(CoBibItemPage, peramiters, {cssClass: 'custom-wide-modal'});
      return profileModal.present({animate: false});
    }else{
      this.toastAlerts.triggerToast("Invalid book", '');
      return null
    }
  }
  public async showDigitalModal(params):Promise<any>{
    if (params.bibDetails){
      let digitalModal = this.modalCtrl.create(CoDigitalItemPage, params, {cssClass: 'custom-wide-modal'});
      return digitalModal.present();
    } else {
      this.toastAlerts.triggerToast("Invalid item", '');
      return null
    }
  }
  public async showItemFromISBN(isbn:string, style?:string){
    const loader = this.loading.create({content: 'Retrieving item information...'});
    loader.present();
    let peramiters = {novelistDetails:null, bibDetails:null, style:style || 'standard'};
    peramiters.novelistDetails = await this.getNovelistData(isbn);
    if(peramiters.novelistDetails && peramiters.novelistDetails.bibids && peramiters.novelistDetails.bibids.length>0){
      peramiters.bibDetails = await this.ils.getBibDetailsFromId(peramiters.novelistDetails.bibids[0]);
    }
    loader.dismiss().catch(err=>{});
    return this.showModal(peramiters);
  }
  public async getParamsFromISBN(isbn:string, style?:string){
    const loader = this.loading.create({content: 'Retrieving item information...'});
    loader.present();
    let peramiters = {novelistDetails:null, bibDetails:null, style:style || 'standard'};
    peramiters.novelistDetails = await this.getNovelistData(isbn);
    if(peramiters.novelistDetails && peramiters.novelistDetails.bibids && peramiters.novelistDetails.bibids.length>0){
      peramiters.bibDetails = await this.ils.getBibDetailsFromId(peramiters.novelistDetails.bibids[0]);
    }
    loader.dismiss().catch(err=>{});
    return peramiters;
  }
  public async showItemFromUPC(upc:string){
    const loader = this.loading.create({content: 'Retrieving item information...'});
    loader.present();
    let peramiters = {novelistDetails:null, bibDetails:null};
    peramiters.novelistDetails = await this.getNovelistData(upc);
    if(peramiters.novelistDetails && peramiters.novelistDetails.bibids && peramiters.novelistDetails.bibids.length>0){
      peramiters.bibDetails = await  this.ils.getBibDetailsFromId(peramiters.novelistDetails.bibids[0]);
    }
    loader.dismiss().catch(err=>{});
    this.showModal(peramiters);
  }
  public async showItemFromBibId(bib, style?:string){
    const loader = this.loading.create({content: 'Retrieving item information...'});
    loader.present();

    let peramiters = {novelistDetails:null, bibDetails:null, style:style || 'standard'};
    if(style)peramiters.style=style;
    if(!bib.source && bib.src) bib.source = bib.src;
    if (bib.source){
      switch(bib.source) {
        case 'sierra':
        case 'polaris':
        case 'sirsi':
          peramiters.bibDetails = await this.ils.getBibDetailsFromId(bib.id.toString());
          if(peramiters.bibDetails && peramiters.bibDetails.upcs && peramiters.bibDetails.upcs.length>0){
            peramiters.novelistDetails = await this.novelist.getItemDetailsFromUPC(peramiters.bibDetails.upcs[0]);
          }else if(peramiters.bibDetails && peramiters.bibDetails.isbns && peramiters.bibDetails.isbns.length>0){
            peramiters.novelistDetails = await this.novelist.getItemDetailsFromISBN(peramiters.bibDetails.isbns[0]);
          }
          // console.log(peramiters);
          loader.dismiss().catch(err=>{});
          this.showModal(peramiters);
        break;
        default:
          this.getDigitalItemInfo(bib).then(info=>{
            let params = {bibDetails: info.bibDetails, style: style || 'standard', novelistDetails: info.novelistDetails}
            loader.dismiss().catch(err=>{});
            this.showDigitalModal(params);
          });
        break;
      }
    } else {
      peramiters.bibDetails = await this.ils.getBibDetailsFromId(bib);
          if(peramiters.bibDetails && peramiters.bibDetails.upcs && peramiters.bibDetails.upcs.length>0){
            peramiters.novelistDetails = await this.novelist.getItemDetailsFromUPC(peramiters.bibDetails.upcs[0]);
          }else if(peramiters.bibDetails && peramiters.bibDetails.isbns && peramiters.bibDetails.isbns.length>0){
            peramiters.novelistDetails = await this.novelist.getItemDetailsFromISBN(peramiters.bibDetails.isbns[0]);
          }
          // console.log(peramiters);
          loader.dismiss().catch(err=>{});
          this.showModal(peramiters);
    }
  }
  public async showItemFromBarcode(barcode:string, style?:string, onlyWithRecomended?: boolean):Promise<any>{
    const loader = this.loading.create({content: 'Retrieving item information...'});
    loader.present();
    let peramiters = {novelistDetails:null, bibDetails:null, style:style || 'standard'};
    peramiters.bibDetails = await this.ils.getBibDetailsFromBarcode(barcode);
    if(peramiters.bibDetails && peramiters.bibDetails.upcs && peramiters.bibDetails.upcs.length>0){
      peramiters.novelistDetails = await this.novelist.getItemDetailsFromUPC(peramiters.bibDetails.upcs[0]);
    }else if(peramiters.bibDetails && peramiters.bibDetails.isbns && peramiters.bibDetails.isbns.length>0){
      peramiters.novelistDetails = await this.novelist.getItemDetailsFromISBN(peramiters.bibDetails.isbns[0]);
    }
    loader.dismiss().catch(err=>{});
    if(onlyWithRecomended && !peramiters.novelistDetails){
      this.toastAlerts.triggerToast("Sorry no suggestions", '');
      return false;
    }else{
      return this.showModal(peramiters);
    }
  }
  async getNovelistData(id: string) {
    if (!id)return null;

    let item;
    if (isIsbn.validate(id.toString())) {
      item = await this.novelist.getItemDetailsFromISBN(id);
    } else {
      item = await this.novelist.getItemDetailsFromUPC(id);
    }
    return item;
  }
  public async getDigitalItemInfo(bib, style?):Promise<any> {
    let params = {bibDetails:bib, style:style || 'standard', novelistDetails: null};
    if(bib.upcs && bib.upcs.length>0){
      params.novelistDetails = await this.novelist.getItemDetailsFromUPC(bib.upcs[0]);
    } else if (bib.isbns && bib.isbns.length>0){
      params.novelistDetails = await this.novelist.getItemDetailsFromUPC(bib.isbns[0]);
    }
    switch(bib.source){
      case 'hoopla':
        params.bibDetails = await this.digitalProvider.getHooplaItemDetails(bib.id);
      break;
      case 'overdrive':
        const overdriveId = bib.ids.find( id => id.type.toLowerCase() === 'overdrive').id;
        params.bibDetails = await this.overdrive.getItemDetailsFromGUID(overdriveId);
      break;
    }
    if(bib.summaries && bib.summaries.length > 0 && !params.bibDetails.summaries) params.bibDetails.summaries = bib.summaries.flat();
    return params;
  }
}



// WEBPACK FOOTER //
// ./src/providers/co-bib-item/co-bib-item.ts